import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import logError from '@utils/logError'
import * as S from './styles'

const AppError = ({ error }: { error: Error | string }) => {
  const { t } = useTranslation('errors')

  useEffect(() => {
    if (error) {
      logError(error)
    }
  }, [error])

  return (
    <S.Container>
      <S.Title>{t('errors:thereIsAnError', 'Ha ocurrido un error')}</S.Title>
      <S.Paragraph>
        {t('errors:tryAgainLater', 'Inténtalo más tarde o escríbenos')} a&nbsp;
        <S.Link href="mailto:support@sentisis.com">support@sentisis.com</S.Link>
      </S.Paragraph>
    </S.Container>
  )
}

export default AppError
